export default "__VITE_ASSET__BoGsx4Yr__"